import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Card, CardPublished } from '../models/card.model';
import { Event } from '../models/event.model';

import * as socketIo from 'socket.io-client';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import { GameState } from './game.service';

const SERVER_URL = environment.socketUrl;

export enum APP_ROLE {
  REMOTE_ROLE = 'remote',
  DIGI_ROLE = 'digi'
}

export enum CATEGORIES {
  ALLES = 'ALLES',
  BIOLOGIE = 'BIOLOGIE',
  WISKUNDE = 'WISKUNDE',
  GEOGRAFIE = 'GEOGRAFIE',
  TAAL = 'TAAL',
  CULTUUR = 'CULTUUR'
}

export enum SOCKET_ERROR {
  NO_REMOTE_DETECTED = 'NO_REMOTE_DETECTED',
  NO_SESSION_DETECTED = 'NO_SESSION_DETECTED',
  MISSING_SESSION_CODE_AND_ROLE = 'MISSING_SESSION_CODE_AND_ROLE'
}

@Injectable()
export class SocketService {
  private socket;
  public connected: boolean = false;

  public initSocket(sessionCode: string, role: APP_ROLE): void {
    if (!isNullOrUndefined(sessionCode)) {
      this.socket = socketIo(SERVER_URL, {
        path: '/connect/socket.io',
        query: 'sessionCode=' + sessionCode + '&role=' + role
      });
      // console.log('API this.socket', this.socket);
    } else {
      throw new Error('Cannot init socket if session code is null');
    }
  }

  public publishCard(card: CardPublished): void {
    if (!isNullOrUndefined(card)) {
      this.socket.emit('card-published', card);
    } else {
      throw new Error('Cannot publish card if card is null');
    }
  }

  public unpublishCard(card: CardPublished): void {
    if (!isNullOrUndefined(card)) {
      this.socket.emit('card-unpublished', card);
    } else {
      throw new Error('Cannot unpublish card if card is null');
    }
  }

  public scoresToggle(value: boolean): void {
      this.socket.emit('scores-toggle', value);
  }

  public filterCategory(category: string): void {
    this.socket.emit('filter-category', category);
  }

  public gameStart(): void {
    this.socket.emit('game-start');
  }

  public gamePause(): void {
    this.socket.emit('game-pause');
  }

  public requestTimeSync(): void {
    this.socket.emit('request-time-sync');
  }

  public timeSync(time: number, state: GameState): void {
    this.socket.emit('time-sync', {
      time: time,
      state: state
    });
  }

  public gameResume(): void {
    this.socket.emit('game-resume');
  }

  public gameStop(): void {
    this.socket.emit('game-stop');
  }

  public disconnect(): void {
    this.socket.disconnect();
  }

  public onScoresToggle(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('scores-toggle', (data: boolean) => {
        observer.next(data);
      });
    });
  }

  public onFilterCategory(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('filter-category', (data: string) => {
        observer.next(data);
      });
    });
  }

  public onCardUnpublished(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('card-unpublished', (data: CardPublished) => {
        observer.next(data);
      });
    });
  }

  public onSocketError(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('socket-error', (data: any) => {
        console.log('socket-error?!', data);
        this.connected = false;
        observer.next(data);
      });
    });
  }

  public onCardPublished(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('card-published', (data: CardPublished) => {
        observer.next(data);
      });
    });
  }

  public onDigiConnection(): Observable<any> {
    // console.log('Call onDigiConnection');
    return new Observable<any>(observer => {
      // console.log('Observable onDigiConnection', observer);
      this.socket.on('digi-connected', (data: any) => {
        console.log('==== DIGI CONNECTED ====');
        this.connected = true;
        observer.next();
      });
    });
  }

  public onRemoteConnection(): Observable<any> {
    // console.log('Call onRemoteConnection');
    return new Observable<any>(observer => {
      // console.log('Observable onRemoteConnection', observer);
      this.socket.on('remote-connected', (data: any) => {
        console.log('==== REMOTE CONNECTED ====');
        observer.next();
      });
    });
  }

  public onGameStart(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('game-start', () => {
        observer.next();
      });
    });
  }

  public onGameStop(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('game-stop', () => {
        observer.next();
      });
    });
  }

  public onGamePause(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('game-pause', () => {
        observer.next();
      });
    });
  }

  public onGameResume(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('game-resume', () => {
        observer.next();
      });
    });
  }

  public onRequestTimeSync(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('request-time-sync', () => {
        observer.next();
      });
    });
  }

  public onTimeSync(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('time-sync', (data) => {
        observer.next(data);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/socket.service.ts